module.exports = __webpack_public_path__ + "static/media/connectionIcon.76dcc5f0.svg";